import React, { useRef, useEffect, useState, useCallback } from "react";
import {
  getQAPaginated,
  addQAPoint,
  editQAPoint,
  deleteQAPoint,
  saveQaPairs,
  GetQaFromDatabaseBySearch,
  softDeleteQa,
} from "../../Api_Qdrant/Flask_Apis";
import { toast } from "react-toastify";
import "./ShowQdrantQa.css";
import "../../app/components/Pagination/Pagination.css";
import Linkify from "linkify-react";
import * as linkify from "linkifyjs";
import addSvg from "../../assets/icons/add.svg";
import deleteSvg from "../../assets/icons/delete.svg";
import mutipleSvg from "../../assets/icons/multiple.svg";
import editSvg from "../../assets/icons/edit-img.svg";
import arrowSvg from "../../assets/icons/arrow.svg";
import searchSvg from "../../assets/icons/search.svg";
import saveSvg from "../../assets/icons/save.svg";
import ConfirmModal from "../../app/components/WarningModel/ConfirmModel";
export default function QuestionsAnswersPage() {
  const [qaList, setQaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingBatch, setLoadingBatch] = useState(false); // for batch loading indicator
  const [showWarningModal, setshowWarningModal] = useState(false);
  const [showWarningModalForBulkDelete, setshowWarningModalForBulkDelete] =
    useState(false);
  const [qAIdToDelete, setqAIdToDelete] = useState(null);
  // Bulk-mode states
  const [bulkMode, setBulkMode] = useState(false);
  const [bulkForm, setBulkForm] = useState([{ question: "", answer: "" }]);
  const [touchedBulk, setTouchedBulk] = useState(false);

  // Single add / edit modal states
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [singleForm, setSingleForm] = useState({
    question: "",
    answer: "",
    is_deleted: false,
  });

  const [totalPoints, setTotalPoints] = useState(0);

  //searching feature
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  //for bulk delete
  const [bulkDeleteMode, setBulkDeleteMode] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  // Client-side pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [isSaving, setIsSaving] = useState(false);

  const bottomRef = useRef(null);
  const nextOffsetRef = useRef(null);

  const collection = "CustomAi";
  const pageSize = 200;

  const linkifyOptions = {
    target: "_blank",
    rel: "noopener noreferrer",
    className: "qa-link",
  };

  useEffect(() => {
    fetchQABatch(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchQABatch = useCallback(
    async (reset = false) => {
      try {
        if (reset) {
          setLoading(true);
          setQaList([]);
          setTotalPoints(0);
          nextOffsetRef.current = null;
          setCurrentPage(1);

          // Load first batch immediately
          const firstBatchData = await getQAPaginated(
            collection,
            pageSize,
            null,
          );

          const firstBatchItems = firstBatchData.result?.qa_list || [];
          nextOffsetRef.current =
            firstBatchData.result.next_page_offset || null;
          const totalQAPoints = firstBatchData.result.total_points || 0;
          setTotalPoints(totalQAPoints);

          // Show first batch immediately
          setQaList(firstBatchItems);
          setLoading(false);

          // Load remaining batches in background if more data available
          if (nextOffsetRef.current && firstBatchItems.length > 0) {
            // Async function to load remaining batches without blocking UI (no loading indicator)
            const loadRemainingBatches = async () => {
              try {
                let totalLoaded = firstBatchItems.length;

                // Continue loading until we reach total QA points from backend
                while (totalLoaded < totalQAPoints) {
                  const data = await getQAPaginated(
                    collection,
                    pageSize,
                    nextOffsetRef.current,
                  );

                  const batchItems = data.result?.qa_list || [];
                  if (batchItems.length === 0) break; // No more data

                  totalLoaded += batchItems.length;
                  nextOffsetRef.current = data.result.next_page_offset || null;

                  // Update UI with new items
                  setQaList((prev) => [...prev, ...batchItems]);

                  // Stop if no more data
                  if (!nextOffsetRef.current) break;

                  // Wait 1 second before fetching next batch
                  if (totalLoaded < totalQAPoints && nextOffsetRef.current) {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                  }
                }
              } catch (err) {
                console.error("Error loading remaining batches:", err);
              }
            };

            // Start loading remaining batches without awaiting (silent background)
            loadRemainingBatches();
          }
        } else {
          setLoadingBatch(true);
        }
      } catch (err) {
        console.error("Error fetching Q&A:", err);
        toast.error("Failed to load Q&A list");
        setLoading(false);
        setLoadingBatch(false);
      }
    },
    [collection, pageSize],
  );

  // ---------- Single add/edit modal ----------
  const openModal = (item = null) => {
    setEditingItem(item);
    setSingleForm(
      item
        ? {
            question: item.question,
            answer: item.answer,
            is_deleted: item.is_deleted,
          }
        : { question: "", answer: "", is_deleted: false },
    );
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setSingleForm({ question: "", answer: "" });
  };

  const handleSingleSave = async () => {
     if (isSaving) return;
    if (!singleForm.question.trim() || !singleForm.answer.trim()) {
      toast.error("Please fill both question and answer.");
      return;
    }

    try {
      setIsSaving(true);
      if (editingItem) {
        var result = await editQAPoint(
          collection,
          editingItem.id,
          singleForm.question,
          singleForm.answer,
          singleForm.is_deleted,
        );
        if (result.success || result.status === "success") {
          toast.success("Q&A updated successfully!");
        } else {
          toast.error(result.message || result.error || "Updation failed");
        }
      } else {
        var result = await addQAPoint(
          collection,
          singleForm.question,
          singleForm.answer,
        );
        if (result.success || result.status === "ok") {
          toast.success("Q&A added successfully!");
        } else {
          toast.error(result.message || result.error || "Failed to add Q&A");
        }
      }

      if (isSearching) {
        await handleSearchChange(searchText);
      } else {
        await fetchQABatch(true);
      }
      closeModal();
    } catch (err) {
      console.error("Save failed:", err);
      toast.error("Failed to save Q&A");
    }
     setIsSaving(false);
  };

  // ---------- Bulk form handlers ----------
  const handleBulkChange = (index, field, value) => {
    setBulkForm((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [field]: value };
      return copy;
    });
  };

  const addBulkRow = () => {
    setBulkForm((prev) => [...prev, { question: "", answer: "" }]);
  };

  const removeBulkRow = (index) => {
    setBulkForm((prev) => {
      const copy = prev.filter((_, i) => i !== index);
      return copy.length ? copy : [{ question: "", answer: "" }];
    });
  };

  const isBulkValid = bulkForm.every(
    (r) => r.question.trim() && r.answer.trim(),
  );

  const handleBulkSave = async () => {
    // show errors if attempted save but invalid
    if (!isBulkValid) {
      setTouchedBulk(true);
      toast.error("Please fill all questions and answers before saving.");
      return;
    }

    try {
      // CALL BULK API HERE:
      // saveQaPairs(collection, bulkForm) -> uses POST /qdrantapi/bulk_qa_insert
      var result = await saveQaPairs(collection, bulkForm);
      if (result.success || result.status === "ok") {
        toast.success("Bulk Q&A saved successfully!");
      } else {
        toast.error(
          result.message || result.error || "Failed to save bulk Q&A",
        );
      }
      if (isSearching) {
        await handleSearchChange(searchText);
      } else {
        await fetchQABatch(true);
      }
      setBulkMode(false);
      setBulkForm([{ question: "", answer: "" }]);
      setTouchedBulk(false);
    } catch (err) {
      console.error("Bulk Save failed:", err);
    }
  };

  useEffect(() => {
    // Removed infinite scroll - using client-side pagination instead
  }, []);

  // ---------- soft single Delete ----------
  const handleSoftDelete = async (id) => {
    try {
      const result = await softDeleteQa(collection, [id]); // passing array of IDs

      // Check if the operation was successful
      if (result.success || result.status === "success") {
        toast.success("Q&A deleted successfully!");

        // Refresh data
        if (isSearching) {
          await handleSearchChange(searchText);
        } else {
          await fetchQABatch(true);
        }
      } else {
        // If the API returns success: false or has error
        console.error("Soft delete API returned error:", result);
        toast.error(result.message || result.error || "Q&A deletion failed");
      }
    } catch (err) {
      console.error("Soft delete failed:", err);
      toast.error(err.message || "Q&A deletion failed");
    }
  };

  // ---------- Client-side Pagination ----------
  const getPaginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return qaList.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    return Math.ceil(qaList.length / itemsPerPage);
  };

  const handlePageChange = (pageNum) => {
    if (!loading && !loadingBatch) {
      setCurrentPage(pageNum);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleItemsPerPageChange = (newSize) => {
    setItemsPerPage(parseInt(newSize));
    setCurrentPage(1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1 && !loading && !loadingBatch) {
      handlePageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < getTotalPages() && !loading && !loadingBatch) {
      handlePageChange(currentPage + 1);
    }
  };

  // ---------- Generate page numbers for pagination ----------
  const generatePageNumbers = () => {
    const totalPages = getTotalPages();
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= maxVisible; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - maxVisible + 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const debouncedSearch = useRef(
    debounce(async (text) => {
      try {
        setSearchLoading(true); // start loader
        const res = await GetQaFromDatabaseBySearch(text);

        if (res?.result?.top_points?.length) {
          const formatted = res.result.top_points.map((p) => ({
            id: p.id,
            question: p.payload.question,
            answer: p.payload.answer,
            score: p.score,
          }));
          console.log(formatted);
          setSearchResults(formatted);
        } else {
          setSearchResults([]);
        }
      } catch (err) {
        console.error("Search failed:", err);
        setSearchResults([]);
      } finally {
        setSearchLoading(false); // stop loader
      }
    }, 1000),
  ).current;

  // ---------- Enhanced Bulk Delete ----------
  const handleBulkDelete = async () => {
    if (selectedIds.length === 0) return;

    try {
      var result = await softDeleteQa(collection, selectedIds);
      console.log("this are the selected IDs:- ", selectedIds);

      if (result.success || result.status === "ok") {
        // Optimistic UI update
        setQaList((prev) => prev.filter((q) => !selectedIds.includes(q.id)));
        setSearchResults((prev) =>
          prev.filter((q) => !selectedIds.includes(q.id)),
        );

        // Show success message
        toast.success(
          `Successfully deleted ${selectedIds.length} ${selectedIds.length > 1 ? "questions" : "question"}`,
        );

        // Reset states
        setSelectedIds([]);
        setSelectAll(false);
        setBulkDeleteMode(false);
      } else {
        console.error("Bulk delete API returned error:", result);
        toast.error(
          result.message ||
            result.error ||
            `Failed to delete ${selectedIds.length > 1 ? "questions" : "question"}`,
        );
      }
    } catch (err) {
      console.error(err);
      toast.error(
        `Failed to delete ${selectedIds.length > 1 ? "questions" : "question"}`,
      );
    }
  };

  // Toggle select all
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds([]);
    } else {
      const allIds = isSearching
        ? searchResults.map((item) => item.id)
        : qaList.map((item) => item.id);
      setSelectedIds(allIds);
    }
    setSelectAll(!selectAll);
  };

  // Handle individual checkbox change
  const handleCheckboxChange = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id)
        ? prev.filter((itemId) => itemId !== id)
        : [...prev, id],
    );
  };

  // Clear all selections
  const clearSelections = () => {
    setSelectedIds([]);
    setSelectAll(false);
  };

  // ---------- Search Handler ----------
  const handleSearchChange = (text) => {
    setSearchText(text);

    if (!text.trim()) {
      setIsSearching(false);
      setSearchLoading(false);
      setSearchResults([]);

      if (searchResults.length > 0) {
        fetchQABatch(true);
      }
      return;
    }

    setIsSearching(true);
    setSearchLoading(true);
    debouncedSearch(text); // only this runs
  };

  // Update select all when selection changes
  useEffect(() => {
    const currentList = isSearching ? searchResults : qaList;
    if (currentList.length > 0 && selectedIds.length === currentList.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedIds, qaList, searchResults, isSearching]);

  const handleModalResponseForSoftDelete = async (choice) => {
    setshowWarningModal(false);
    if (choice == "no") {
      return;
    } else if (choice == "yes") {
      handleSoftDelete(qAIdToDelete);
      setqAIdToDelete(null);
    }
  };

  const handleModalResponseForBulkDelete = async (choice) => {
    setshowWarningModalForBulkDelete(false);
    if (choice == "no") {
      return;
    } else if (choice == "yes") {
      handleBulkDelete();
    }
  };

  return (
    <>
      <div className="role-box">
        <h2>Saved Q/A</h2>
        <div className="show-saved">
          <div className="form-wraper">
            <label>Search</label>
            <input
              type="text"
              className="search qa-search-input"
              placeholder="Search question..."
              value={searchText}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
            <img src={searchSvg} alt="Search" />
          </div>
          <div className="d-flex align-items-center flex-wrap gap-10">
            {!bulkDeleteMode && (
              <>
                <button
                  className="primary_btn mr_10"
                  onClick={() => openModal(null)}
                >
                  <img src={addSvg} alt="Add" />
                  Add New
                </button>

                <button
                  className={`mutiple-btn mr_10 ${bulkMode ? "active" : ""}`}
                  onClick={() => {
                    setBulkMode((v) => !v);
                    setTouchedBulk(false);
                  }}
                >
                  <img
                    src={bulkMode ? arrowSvg : mutipleSvg}
                    alt={bulkMode ? "Back" : "Multiple"}
                  />
                  {bulkMode ? " Back" : " Multiple"}
                </button>
              </>
            )}
            <button
              className={`delete-btn ${bulkDeleteMode ? "" : ""}`}
              onClick={() => {
                setBulkDeleteMode((v) => !v);
                if (bulkDeleteMode) {
                  clearSelections();
                }
              }}
            >
              <img src={deleteSvg} alt="Delete " />
              {bulkDeleteMode ? "Cancel" : "Bulk Delete"}
            </button>
          </div>
        </div>
      </div>
      <div className="qa-page">
        {/* Header */}
        <div className="qa-header">
          <h2>All Questions & Answers</h2>
        </div>

        {/* Bulk Delete Toolbar */}
        {bulkDeleteMode && (
          <div className="qa-bulk-toolbar">
            <div className="qa-bulk-toolbar-left">
              <label className="qa-select-all-label">
                <input
                  type="checkbox"
                  className="qa-checkbox"
                  checked={selectAll}
                  onChange={toggleSelectAll}
                />
                <span>Select All</span>
              </label>

              <div className="qa-selection-info">
                {selectedIds.length > 0 ? (
                  <>
                    <span className="qa-selected-count">
                      {selectedIds.length}
                    </span>
                    <span>
                      {" "}
                      of {isSearching
                        ? searchResults.length
                        : qaList.length}{" "}
                      selected
                    </span>
                  </>
                ) : (
                  <span>No items selected</span>
                )}
              </div>
            </div>

            <div className="qa-bulk-toolbar-right">
              {selectedIds.length > 0 && (
                <button className="cancel-btn" onClick={clearSelections}>
                  <i className="bi bi-x-lg"></i>
                  Clear
                </button>
              )}

              <button
                className="delete-btn"
                disabled={selectedIds.length === 0}
                onClick={() => setshowWarningModalForBulkDelete(true)}
              >
                <img src={deleteSvg} alt="Delete" />
                Delete ({selectedIds.length})
              </button>
            </div>
          </div>
        )}

        {/* Bulk Insert Form */}
        {bulkMode ? (
          <div className="p-20">
            <div className="qa-bulk-form card">
              <div className="qa-bulk-header">
                <h3> Add Multiple Questions</h3>
                <div className="qa-bulk-info">
                  <span>{bulkForm.length} row(s)</span>
                </div>
              </div>

              <div className="qa-bulk-rows">
                {bulkForm.map((row, i) => {
                  const qEmpty = !row.question.trim();
                  const aEmpty = !row.answer.trim();
                  return (
                    <div key={i} className="qa-bulk-row">
                      <div className="qa-bulk-col index-col">{i + 1}</div>

                      <div>
                        <div className="qa-bulk-col form-wraper-bx">
                          <label className="label">Question</label>
                          <input
                            className={`form-control ${
                              touchedBulk && qEmpty ? "error" : ""
                            }`}
                            type="text"
                            placeholder="Question"
                            value={row.question}
                            onChange={(e) =>
                              handleBulkChange(i, "question", e.target.value)
                            }
                          />
                        </div>

                        <div className="qa-bulk-col form-wraper-bx">
                          <label className="label">Answer</label>
                          <textarea
                            className={`form-control ${
                              touchedBulk && aEmpty ? "error" : ""
                            }`}
                            rows={2}
                            placeholder="Answer"
                            value={row.answer}
                            onChange={(e) =>
                              handleBulkChange(i, "answer", e.target.value)
                            }
                          />
                        </div>

                        <div className="d-flex justify-content-end">
                          <button
                            className="delete-btn"
                            onClick={() => removeBulkRow(i)}
                          >
                            <img src={deleteSvg} alt="Delete" />
                            Remove row
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="qa-bulk-actions">
                <button className="primary_btn" onClick={addBulkRow}>
                  <img src={addSvg} alt="Add" />
                  Add Row
                </button>

                <div style={{ flex: 1 }} />

                <button
                  className="cancel-btn"
                  onClick={() => {
                    setBulkMode(false);
                    setTouchedBulk(false);
                  }}
                >
                  Cancel
                </button>

                <button
                  className={`primary_btn ${!isBulkValid ? "disabled" : ""}`}
                  onClick={handleBulkSave}
                  disabled={!isBulkValid}
                >
                  <img src={saveSvg} alt="Save" />
                  Save All
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Q&A List */}
            {isSearching ? (
              <>
                {searchLoading ? (
                  <div className="qa-full-loader">
                    <div className="spinner"></div>
                    <p>Searching questions...</p>
                  </div>
                ) : searchResults.length > 0 ? (
                  <div className="qa_list">
                    {searchResults.map((item, idx) => (
                      <div className="d-flex aling-items-center mb-20">
                        {bulkDeleteMode && (
                          <div className="qa-select-overlay mr_10">
                            <input
                              type="checkbox"
                              className="qa-checkbox qa-item-checkbox"
                              checked={selectedIds.includes(item.id)}
                              onChange={() => handleCheckboxChange(item.id)}
                            />
                          </div>
                        )}

                        <div
                          key={item.id || idx}
                          className={`qa-card card ${
                            selectedIds.includes(item.id) ? "selected" : ""
                          }`}
                        >
                          <div className="qa-card-body">
                            <div className="qa-content">
                              <p>
                                <strong>{idx + 1}. Question:</strong>{" "}
                                <Linkify options={linkifyOptions}>
                                  {item.question}
                                </Linkify>
                              </p>
                              <p>
                                <strong>Answer:</strong>{" "}
                                <Linkify options={linkifyOptions}>
                                  {item.answer}
                                </Linkify>
                              </p>

                              {!bulkDeleteMode && (
                                <div className="qa-actions">
                                  <button
                                    className="edit-btn"
                                    onClick={() => openModal(item)}
                                  >
                                    <img src={editSvg} alt="Edit" />
                                    Edit
                                  </button>

                                  <button
                                    className="delete-btn"
                                    onClick={() => {
                                      setqAIdToDelete(item.id);
                                      setshowWarningModal(true);
                                    }}
                                  >
                                    <img src={deleteSvg} alt="Delete" />
                                    Delete
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="qa-empty-state">
                    <p>No results found...</p>
                  </div>
                )}
              </>
            ) : (
              // 👉 NORMAL LIST VIEW
              <>
                {loading && qaList.length === 0 ? (
                  <div className="qa-full-loader">
                    <div className="spinner"></div>
                    <p>Loading questions...</p>
                  </div>
                ) : qaList.length > 0 ? (
                  <>
                    <div className="qa_list">
                      {getPaginatedData().map((item, idx) => (
                        <div className="d-flex aling-items-center mb-20">
                          {bulkDeleteMode && (
                            <div className="qa-select-overlay mr_10">
                              <input
                                type="checkbox"
                                className="qa-checkbox qa-item-checkbox"
                                checked={selectedIds.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                            </div>
                          )}
                          <div
                            key={item.id}
                            className={`qa-card card ${
                              selectedIds.includes(item.id) ? "selected" : ""
                            }`}
                          >
                            <div className="qa-card-body">
                              <div className="qa-content">
                                <p>
                                  <strong>
                                    {(currentPage - 1) * itemsPerPage + idx + 1}
                                    . Question:
                                  </strong>{" "}
                                  <Linkify options={linkifyOptions}>
                                    {item.question}
                                  </Linkify>
                                </p>

                                <p>
                                  <strong>Answer:</strong>{" "}
                                  <Linkify options={linkifyOptions}>
                                    {item.answer}
                                  </Linkify>
                                </p>

                                {!bulkDeleteMode && (
                                  <div className="qa-actions">
                                    <button
                                      className="edit-btn"
                                      onClick={() => openModal(item)}
                                    >
                                      <img src={editSvg} alt="Edit" />
                                      Edit
                                    </button>

                                    <button
                                      className="delete-btn "
                                      onClick={() => {
                                        setqAIdToDelete(item.id);
                                        setshowWarningModal(true);
                                      }}
                                    >
                                      <img src={deleteSvg} alt="Delete" />
                                      Delete
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <div ref={bottomRef} style={{ height: "1px" }}></div>
                  </>
                ) : (
                  <div className="qa-empty-state">
                    <p>No data found.</p>
                  </div>
                )}
              </>
            )}
          </>
        )}

        {/* Single Add/Edit Modal */}
        {showModal && (
          <div className="qa-modal-overlay" onMouseDown={closeModal}>
            <div className="qa-modal" onMouseDown={(e) => e.stopPropagation()}>
              <div className="qa-modal-header">
                <h5>{editingItem ? "Edit Q&A" : "Add Q&A"}</h5>
                <button className="qa-btn-close" onClick={closeModal}>
                  ✖
                </button>
              </div>

              <div className="qa-modal-body">
                <div className="form-wraper-bx">
                  <label className="label">Question</label>

                  <input
                    className="form-control"
                    type="text"
                    value={singleForm.question}
                    onChange={(e) =>
                      setSingleForm((s) => ({ ...s, question: e.target.value }))
                    }
                    placeholder="Enter question"
                  />
                </div>
                <div className="form-wraper-bx">
                  <label className="label">Answer</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={singleForm.answer}
                    onChange={(e) =>
                      setSingleForm((s) => ({ ...s, answer: e.target.value }))
                    }
                    placeholder="Enter answer"
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className="delete_approve_btn"
                    onClick={handleSingleSave}
                  >
                    Save
                  </button>
                  <button className="delete_reject_btn" onClick={closeModal}>
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {!isSearching && !bulkMode && (
        <div className="pagination_wraper">
          <div className="d-flex align-items-center">
            <div>
              <label className="page-size">
                Page <strong>{currentPage}</strong> of{" "}
                <strong>{itemsPerPage}</strong>{" "}
              </label>
            </div>
            <div className="PageSizeChageDropdown">
              <select
                value={itemsPerPage}
                onChange={(e) => handleItemsPerPageChange(e.target.value)}
                disabled={loading || loadingBatch}
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>

          <div className="page">
            <div
              className={`${currentPage === 1 || loading || loadingBatch ? "disabled" : "page__btn_qdrant"}`}
              onClick={handlePrevPage}
            >
              <img
                src={require("../../assets/images/arrow.png")}
                className="material-icons left_arrow"
                alt="Arrow"
              />
            </div>

            {/* Page Numbers */}
            {generatePageNumbers().map((pageNum, idx) => (
              <div
                key={idx}
                className={`page__numbers ${
                  pageNum === currentPage ? "active_page" : ""
                } ${pageNum === "..." ? "ellipsis" : ""}`}
                onClick={() => pageNum !== "..." && handlePageChange(pageNum)}
                style={{
                  cursor:
                    pageNum === "..." || loading || loadingBatch
                      ? "default"
                      : "pointer",
                  opacity: loading || loadingBatch ? 0.5 : 1,
                }}
              >
                {pageNum}
              </div>
            ))}

            <div
              className={`${currentPage === getTotalPages() || qaList.length === 0 || loading || loadingBatch ? "disabled" : "page__btn_qdrant"}`}
              onClick={handleNextPage}
            >
              <img
                src={require("../../assets/images/arrow.png")}
                className="material-icons"
                alt="Arrow"
              />
            </div>
          </div>

          {/* <div className="pagination-info">
            <span>
              {qaList.length > 0
                ? `${(currentPage - 1) * itemsPerPage + 1} - ${Math.min(
                    currentPage * itemsPerPage,
                    qaList.length,
                  )} of ${qaList.length}`
                : "No data"}
            </span>
          </div> */}
        </div>
      )}

      {showWarningModal && (
        <ConfirmModal
          title="Action Required"
          message="Are you sure you want to delete this question?"
          confirmText="Yes, I'm Sure"
          cancelText="Cancel"
          onClose={handleModalResponseForSoftDelete}
        />
      )}

      {showWarningModalForBulkDelete && (
        <ConfirmModal
          title="Action Required"
          message={`Are you sure you want to delete ${selectedIds.length} ${selectedIds.length > 1 ? "questions" : "question"}?`}
          confirmText="Yes, I'm Sure"
          cancelText="Cancel"
          onClose={handleModalResponseForBulkDelete}
        />
      )}
    </>
  );
}
